import {MutableRefObject} from 'react';

import {executeToolbarCommand} from '../utils/editorCommands';
import {RichTextBlockFormat} from '../utils/selectionHelpers';

export function useEditorFormat(
  editorRef: MutableRefObject<HTMLDivElement | null>,
  selectionRef: MutableRefObject<Range | null>,
  syncEditorState: () => void,
  updateMetadata: () => void
) {
  const handleCommandClick = (command: string) => {
    executeToolbarCommand(editorRef.current, selectionRef, command);
    syncEditorState();
    updateMetadata();
  };

  const handleFormatChange = (value: RichTextBlockFormat | null) => {
    if (!value) {
      return;
    }

    executeToolbarCommand(editorRef.current, selectionRef, 'formatBlock', `<${value}>`);
    syncEditorState();
    updateMetadata();
  };

  return {
    handleCommandClick,
    handleFormatChange,
  };
}
